/** useListino + useUpdateTariffa — F-009.4 (admin listino). */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import type { PraticaTipologiaValue } from '@app/shared';

import {
  getListino,
  updateTariffa,
  errorMessageFor,
  type ListinoListResponse,
  type UpdateTariffaPrices,
} from '../lib/listino-client';
import { listinoQueryKey } from '../lib/query-client';

export function useListino() {
  return useQuery<ListinoListResponse>({
    queryKey: listinoQueryKey,
    queryFn: getListino,
  });
}

export function useUpdateTariffa() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { tipologia: PraticaTipologiaValue } & UpdateTariffaPrices) => {
      const { tipologia, ...prices } = vars;
      return updateTariffa(tipologia, prices);
    },
    onSuccess: () => {
      toast.success('Prezzo aggiornato.');
      void qc.invalidateQueries({ queryKey: listinoQueryKey });
    },
    onError: (err) => {
      toast.error(errorMessageFor(err));
    },
  });
}
